import React from 'react';

const VersionDetailsTable = ({ statistics }) => {
  // Préparer les données pour chaque composant
  const prepareTableData = (data) => {
    return Object.entries(data)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value);
  };

  // Calculer le pourcentage
  const getPercentage = (value, total) => {
    return total > 0 ? Math.round((value / total) * 100) : 0;
  };

  // Créer les lignes du tableau pour un composant
  const renderComponentRows = (componentName, data, bgColor) => {
    const items = prepareTableData(data);
    const total = items.reduce((sum, item) => sum + item.value, 0);

    if (items.length === 0) return null;

    return items.map((item, index) => (
      <tr key={`${componentName}-${index}`} className={index === 0 ? bgColor : ''}>
        {index === 0 && (
          <td 
            rowSpan={items.length} 
            className="px-6 py-4 whitespace-nowrap font-medium border-r"
          >
            {componentName}
          </td>
        )}
        <td className="px-6 py-4 whitespace-nowrap">{item.name}</td>
        <td className="px-6 py-4 whitespace-nowrap text-center">{item.value}</td>
        <td className="px-6 py-4 whitespace-nowrap text-center">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            {getPercentage(item.value, total)}%
          </span>
        </td>
      </tr>
    ));
  };

  const components = [
    { name: 'MariaDB', data: statistics.mariadb, bgColor: 'bg-blue-50' },
    { name: 'Apache', data: statistics.apache, bgColor: 'bg-green-50' },
    { name: 'Node.js', data: statistics.nodejs, bgColor: 'bg-yellow-50' },
    { name: 'Patient App', data: statistics.patientApp, bgColor: 'bg-red-50' },
    { name: 'Manager Front', data: statistics.managerFront, bgColor: 'bg-purple-50' },
    { name: 'Marshaller', data: statistics.marshaller, bgColor: 'bg-pink-50' },
    { name: 'Marshaller Interop', data: statistics.marshallerInterop, bgColor: 'bg-indigo-50' }
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">Détails par Composant</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Composant
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Version
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Nombre
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Pourcentage
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {components.map(component => 
              renderComponentRows(component.name, component.data, component.bgColor)
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VersionDetailsTable;